import { ThemeComponent } from "@/theme/ThemeComponent";
import { Component, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { CartItemRow } from "./CartItemRow";
import { cart } from "@/theme/Cart";
import { QuantitySpinner } from "../QuantitySpinner/QuantitySpinner";

@Component
export class CartMain extends ThemeComponent {
    @Ref() checkoutButton!: HTMLAnchorElement;
    @Ref() emptyCart!: HTMLElement;
    @Ref() promoBanner!: HTMLElement;
    @Ref() items!: HTMLElement;
    @Ref() count!: HTMLElement;

    protected strings = this.dataset.strings? this.dataset.strings: '';
    private itemCount: number = 0;

    /**
     * Initialise.
     */
    init() {
        this.$subscribe(cart.onChange, () => this.cartUpdated());
        this.cartUpdated();
        this.checkFreeGift();
    }

    /**
     * Update item count.
     * @param count - count
     */
    updateCount(count:number) {
        this.count.innerHTML = String(count);
    }

    /**
     * Update Cart
     * @param container - items container.
     * @param emptyCart - cart empty message.
     * @returns
     */
    cartUpdated() {
        const itemsLength = cart.items.length;
        this.items.innerHTML = '';

        let length = 0;

        if (itemsLength <= 0) {
            this.emptyCart.style.display = 'block';
            this.checkoutButton.style.display ='none';
            return;
        }

        this.emptyCart.style.display = 'none';
        this.checkoutButton.style.display ='block';
        this.itemCount = 0;

        for (const item of cart.items) {
            const row = new CartItemRow(item, new QuantitySpinner(1 , 99, item.quantity), this.strings);

            this.itemCount += item.quantity; length++;
            this.items.append(row);

            if (length < itemsLength) { continue; }
            this.updateCount(this.itemCount);
        }
    }

    /**
     * Cheeck if eligible for free gift.
     * - free gift query is defined within Cart.ts
     */
    checkFreeGift() {
        this.promoBanner.style.display = cart.qualifiesForFreeGift ? '' : 'none';
    }
}
